import { render, staticRenderFns } from "./vinMoreInfo.vue?vue&type=template&id=8409aefe&scoped=true&"
import script from "./vinMoreInfo.vue?vue&type=script&lang=js&"
export * from "./vinMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./vinMoreInfo.vue?vue&type=style&index=0&id=8409aefe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8409aefe",
  null
  
)

export default component.exports